import { render, staticRenderFns } from "./DuckEnvelope.vue?vue&type=template&id=3627a25d&scoped=true"
import script from "./DuckEnvelope.vue?vue&type=script&lang=js"
export * from "./DuckEnvelope.vue?vue&type=script&lang=js"
import style1 from "./DuckEnvelope.vue?vue&type=style&index=1&id=3627a25d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627a25d",
  null
  
)

export default component.exports